<div class="w-full mx-auto min-h-screen p-5 bg-gray-50">
  <!-- Header Section -->
  <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-3xl font-bold text-gray-900 mb-2">Registrar Nueva Empresa</h1>
        <p class="text-gray-600">Complete la información de la empresa</p>
      </div>
      <button 
        type="button" 
        (click)="goBack()" 
        class="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition-colors">
        <i class="fas fa-arrow-left mr-2"></i>Volver
      </button>
    </div>
  </div>

  <!-- Form Section -->
  <div class="bg-white rounded-lg shadow-sm p-6">
    <form [formGroup]="companyForm" (ngSubmit)="onSubmit()" class="space-y-6">
      <!-- Información de la Empresa -->
      <div class="border border-gray-200 rounded-lg p-6 mb-6">
        <h2 class="text-xl font-semibold text-gray-900 mb-4 flex items-center">
          <i class="fas fa-building mr-2 text-blue-500"></i>Información de la Empresa
        </h2>
        
        <div class="mb-6">
          <label for="name" class="block text-sm font-medium text-gray-700 mb-2" appRequiredLabel>Nombre de la Empresa</label>
          <input 
            type="text" 
            id="name" 
            formControlName="name" 
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            placeholder="Ingrese el nombre de la empresa">
          <div *ngIf="companyForm.get('name')?.invalid && companyForm.get('name')?.touched" 
               class="text-red-500 text-sm mt-1 flex items-center">
            <i class="fas fa-exclamation-circle mr-1"></i>
            El campo Nombre de la Empresa es obligatorio y debe tener máximo 100 caracteres.
          </div>
        </div>
      </div>
  
      <!-- Información de Identificación -->
      <div class="border border-gray-200 rounded-lg p-6 mb-6">
        <h2 class="text-xl font-semibold text-gray-900 mb-4 flex items-center">
          <i class="fas fa-id-card mr-2 text-green-500"></i>Información de Identificación
        </h2>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label for="typeDocument" class="block text-sm font-medium text-gray-700 mb-2">Tipo de Documento</label>
            <input 
              type="text" 
              id="typeDocument" 
              formControlName="typeDocument" 
              readonly
              class="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              placeholder="NIT (automático)">
          </div>

          <div>
            <label for="documentId" class="block text-sm font-medium text-gray-700 mb-2" appRequiredLabel>Número de Documento</label>
            <input 
              type="text" 
              id="documentId" 
              formControlName="documentId" 
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              placeholder="Ingrese el número de NIT">
            <div *ngIf="companyForm.get('documentId')?.invalid && companyForm.get('documentId')?.touched" 
                 class="text-red-500 text-sm mt-1 flex items-center">
              <i class="fas fa-exclamation-circle mr-1"></i>
              El campo Número de Documento es obligatorio y debe tener máximo 20 caracteres.
            </div>
          </div>
        </div>
      </div>
  
      <!-- Información de Contacto -->
      <div class="border border-gray-200 rounded-lg p-6 mb-6">
        <h2 class="text-xl font-semibold text-gray-900 mb-4 flex items-center">
          <i class="fas fa-envelope mr-2 text-purple-500"></i>Información de Contacto
        </h2>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700 mb-2" appRequiredLabel>Correo Electrónico</label>
            <input 
              type="email" 
              id="email" 
              formControlName="email" 
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              placeholder="correo@empresa.com">
            <div *ngIf="companyForm.get('email')?.invalid && companyForm.get('email')?.touched" 
                 class="text-red-500 text-sm mt-1 flex items-center">
              <i class="fas fa-exclamation-circle mr-1"></i>
              El campo Correo Electrónico es obligatorio y debe ser válido.
            </div>
          </div>

          <div>
            <label for="phone" class="block text-sm font-medium text-gray-700 mb-2" appRequiredLabel>Teléfono</label>
            <input 
              type="tel" 
              id="phone" 
              formControlName="phone" 
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              placeholder="(1) 234 5678">
            <div *ngIf="companyForm.get('phone')?.invalid && companyForm.get('phone')?.touched" 
                 class="text-red-500 text-sm mt-1 flex items-center">
              <i class="fas fa-exclamation-circle mr-1"></i>
              El campo Teléfono es obligatorio y debe ser válido.
            </div>
          </div>
        </div>
      </div>

      <!-- Información de Ubicación -->
      <div class="border border-gray-200 rounded-lg p-6 mb-6">
        <h2 class="text-xl font-semibold text-gray-900 mb-4 flex items-center">
          <i class="fas fa-map-marker-alt mr-2 text-red-500"></i>Información de Ubicación
        </h2>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label for="country" class="block text-sm font-medium text-gray-700 mb-2" appRequiredLabel>País</label>
            <input 
              type="text" 
              id="country" 
              formControlName="country" 
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              placeholder="Colombia">
            <div *ngIf="companyForm.get('country')?.invalid && companyForm.get('country')?.touched" 
                 class="text-red-500 text-sm mt-1 flex items-center">
              <i class="fas fa-exclamation-circle mr-1"></i>
              País es obligatorio.
            </div>
          </div>

          <div>
            <label for="city" class="block text-sm font-medium text-gray-700 mb-2" appRequiredLabel>Ciudad</label>
            <input 
              type="text" 
              id="city" 
              formControlName="city" 
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
              placeholder="Bogotá">
            <div *ngIf="companyForm.get('city')?.invalid && companyForm.get('city')?.touched" 
                 class="text-red-500 text-sm mt-1 flex items-center">
              <i class="fas fa-exclamation-circle mr-1"></i>
              Ciudad es obligatorio.
            </div>
          </div>
        </div>

        <div class="mt-6">
          <label for="addressLine1" class="block text-sm font-medium text-gray-700 mb-2" appRequiredLabel>Dirección Principal</label>
          <input 
            type="text" 
            id="addressLine1" 
            formControlName="addressLine1" 
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            placeholder="Calle 123 # 45-67">
          <div *ngIf="companyForm.get('addressLine1')?.invalid && companyForm.get('addressLine1')?.touched" 
               class="text-red-500 text-sm mt-1 flex items-center">
            <i class="fas fa-exclamation-circle mr-1"></i>
            El campo Dirección Línea 1 es obligatorio y debe tener máximo 100 caracteres.
          </div>
        </div>

        <div class="mt-6">
          <label for="addressLine2" class="block text-sm font-medium text-gray-700 mb-2">Dirección Complementaria</label>
          <input 
            type="text" 
            id="addressLine2" 
            formControlName="addressLine2" 
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            placeholder="Apartamento, oficina, edificio (opcional)">
        </div>
      </div>

      <!-- Botones de Acción -->
      <div class="flex justify-end space-x-4 pt-6 border-t border-gray-200">
        <button 
          type="button" 
          (click)="goBack()" 
          class="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors">
          Cancelar
        </button>
        <button 
          type="submit" 
          [disabled]="!companyForm.valid" 
          [class]="companyForm.valid ? 'bg-blue-500 hover:bg-blue-600' : 'bg-gray-300 cursor-not-allowed'"
          class="px-6 py-3 text-white rounded-lg transition-colors flex items-center">
          <i class="fas fa-save mr-2"></i>
          Guardar Empresa
        </button>
      </div>
    </form>
  </div>
</div>
  